import React, { useCallback, useEffect, useMemo, useRef, useState, forwardRef, createContext } from 'react';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
const emptyFn = () => { };
export const VScrollContent = createContext({
    regiestIframe: emptyFn,
    unregisterIframe: emptyFn,
    handleHorizontalScroll: emptyFn,
    setContentWidth: emptyFn,
});
const useFixedScroolBar = (config) => {
    const { contentRectTopOffset = 0, contentRectBottomOffset = 0 } = config || {};
    const contentRefMap = useRef({});
    const [stateMap, setStateMap] = useState({});
    const [activeTab, setActiveTab] = useState(null);
    const vrticalScrollWrapRef = useRef();
    const contentGroupWrapRef = useRef();
    const [contentWidthMap, setContentWidthMap] = useState({});
    const [viewWidthMap, setViewWidthMap] = useState({});
    const vScrollBarShow = useMemo(() => {
        var _a;
        return (!!activeTab && !!(contentWidthMap[activeTab] && contentRefMap.current[activeTab] && contentWidthMap[activeTab] > ((_a = contentRefMap.current[activeTab]) === null || _a === void 0 ? void 0 : _a.clientWidth)));
    }, [activeTab, contentWidthMap]);
    const vScrollBarLeft = useMemo(() => {
        return activeTab ? stateMap[activeTab] || 0 : 0;
    }, [activeTab, stateMap]);
    const vScrollBarWidth = useMemo(() => {
        return activeTab && contentWidthMap ? contentWidthMap[activeTab] : 0;
    }, [activeTab, contentWidthMap]);
    const vScrollBarViewWidth = useMemo(() => {
        return activeTab && viewWidthMap ? viewWidthMap[activeTab] : 0;
    }, [activeTab, viewWidthMap]);
    const setContentWidth = useCallback((key, contentWidth, viewWidth) => {
        if (key) {
            setContentWidthMap(map => {
                return Object.assign(Object.assign({}, map), { [key]: contentWidth });
            });
            setViewWidthMap(map => {
                return Object.assign(Object.assign({}, map), { [key]: viewWidth });
            });
        }
    }, []);
    const setContentWidthRef = useCreateCallbackForEvent(setContentWidth);
    const updateScrollBarState = useCallback(() => {
        var _a, _b, _c;
        if (!(vrticalScrollWrapRef === null || vrticalScrollWrapRef === void 0 ? void 0 : vrticalScrollWrapRef.current) || ((_a = vrticalScrollWrapRef === null || vrticalScrollWrapRef === void 0 ? void 0 : vrticalScrollWrapRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) == null) {
            return false;
        }
        const aimRect = (_b = vrticalScrollWrapRef === null || vrticalScrollWrapRef === void 0 ? void 0 : vrticalScrollWrapRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        const line = (aimRect === null || aimRect === void 0 ? void 0 : aimRect.top) + aimRect.height;
        const rangList = [];
        if (contentRefMap.current) {
            for (let i in contentRefMap.current) {
                const item = contentRefMap.current[i];
                if (item) {
                    const config = item.getBoundingClientRect();
                    rangList.push({
                        start: config.top + contentRectTopOffset,
                        end: config.height + config.top + contentRectBottomOffset,
                        key: i,
                    });
                }
            }
        }
        const res = rangList.find(item => line > item.start && line < item.end);
        if (res) {
            setActiveTab(res.key);
            if (stateMap &&
                stateMap[res.key] != null &&
                contentRefMap.current[res.key] != null &&
                stateMap[res.key] != ((_c = contentRefMap.current[res.key]) === null || _c === void 0 ? void 0 : _c.contentDocument.documentElement.scrollLeft)) {
                setStateMap(map => {
                    var _a;
                    map[res.key] = (_a = contentRefMap.current[res.key]) === null || _a === void 0 ? void 0 : _a.contentDocument.documentElement.scrollLeft;
                    return map;
                });
            }
        }
        else {
            setActiveTab(null);
        }
    }, [stateMap, setStateMap, contentRectTopOffset, contentRectBottomOffset]);
    const updateScrollBarStateRef = useCreateCallbackForEvent(updateScrollBarState);
    const handleVScrollOnScroll = useCallback(sl => {
        if (activeTab && contentRefMap.current[activeTab]) {
            contentRefMap.current[activeTab].contentDocument.documentElement.scrollLeft = sl;
        }
        setStateMap(res => {
            res[activeTab] = sl;
            return res;
        });
    }, [activeTab]);
    const handleVScrollOnScrollRef = useCreateCallbackForEvent(handleVScrollOnScroll);
    const handleHorizontalScroll = useCallback((refkey, left) => {
        setStateMap(res => {
            return Object.assign(Object.assign({}, res), { [refkey]: left });
        });
    }, []);
    const WrapCompenent = useCallback((props) => {
        const { className } = props;
        return (React.createElement(VScrollContent.Provider, { value: {
                regiestIframe: (key, iframeElement) => {
                    try {
                        if (contentRefMap.current && key) {
                            contentRefMap.current[key] = iframeElement;
                        }
                    }
                    catch (e) {
                        console.error('regiestIframe error:', e);
                    }
                },
                unregisterIframe: (key) => {
                    try {
                        if (contentRefMap.current && key) {
                            delete contentRefMap.current[key];
                        }
                    }
                    catch (e) {
                        console.error('unregisterIframe error:', e);
                    }
                },
                handleHorizontalScroll,
                setContentWidth,
            } },
            React.createElement("div", Object.assign({}, props, { className: className ? className + ' vscrollbar-wrap-readmail' : '' }), props.children)));
    }, []);
    const VrticalScrollWrapComponent = useCallback(forwardRef((props, ref) => {
        const { onScroll } = props;
        return (React.createElement("div", Object.assign({}, props, { ref: _ref => {
                if (vrticalScrollWrapRef) {
                    vrticalScrollWrapRef.current = _ref;
                }
                if (ref && ref.current !== undefined) {
                    ref.current = _ref;
                }
            }, onScroll: event => {
                updateScrollBarStateRef(event);
                if (onScroll && typeof onScroll === 'function') {
                    onScroll(event);
                }
            } }), props.children));
    }), []);
    const HorizontalScrollWrapComponent = useCallback((props) => {
        const { onScroll, refkey, _ref } = props;
        return (React.createElement("div", Object.assign({}, props, { ref: () => {
                contentRefMap.current[refkey] = _ref;
            }, onScroll: event => {
                const target = event.target;
                const leftOffset = target.scrollLeft;
                setStateMap(res => {
                    return Object.assign(Object.assign({}, res), { [refkey]: leftOffset });
                });
                if (onScroll && typeof onScroll === 'function') {
                    onScroll(event);
                }
            } }), props.children));
    }, []);
    const ContentMeasurement = useMemo(() => (props) => {
        useEffect(() => {
            const observer = new ResizeObserver(() => {
                updateScrollBarStateRef();
            });
            const currentRef = contentGroupWrapRef === null || contentGroupWrapRef === void 0 ? void 0 : contentGroupWrapRef.current;
            if (currentRef) {
                observer.observe(currentRef);
            }
            return () => {
                observer.disconnect();
            };
        }, []);
        return (React.createElement("div", Object.assign({}, props, { ref: contentGroupWrapRef }), props.children));
    }, []);
    return {
        WrapCompenent,
        VrticalScrollWrapComponent,
        HorizontalScrollWrapComponent,
        ContentMeasurement,
        activeTab,
        handleVScrollOnScroll: handleVScrollOnScrollRef,
        setContentWidth: setContentWidthRef,
        vScrollBarShow,
        vScrollBarLeft,
        vScrollBarWidth,
        vScrollBarViewWidth,
        handleHorizontalScroll,
    };
};
export default useFixedScroolBar;
